import { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=user
  const [error, setError] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("btt_token");
    if (!token) { setUser(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => { localStorage.removeItem("btt_token"); setUser(false); });
  }, []);

  const login = async (email, password) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("btt_token", data.access_token);
      setUser(data);
      return { ok: true };
    } catch (e) {
      const detail = e?.response?.data?.detail;
      if (e?.response?.status === 402 && detail?.code === "purchase_required") {
        setError(detail.message || "Purchase required.");
        return { ok: false, purchaseRequired: true, checkoutUrl: detail.checkout_url || "" };
      }
      setError(formatApiError(e));
      return { ok: false };
    }
  };

  const adminLogin = async (email, password) => {
    setError("");
    try {
      const { data } = await api.post("/admin/auth/login", { email, password });
      localStorage.setItem("btt_token", data.access_token);
      setUser(data);
      return true;
    } catch (e) { setError(formatApiError(e)); return false; }
  };

  const register = async (email, password, name) => {
    setError("");
    try {
      const { data } = await api.post("/auth/register", { email, password, name });
      localStorage.setItem("btt_token", data.access_token);
      setUser(data);
      return { ok: true };
    } catch (e) {
      const detail = e?.response?.data?.detail;
      if (e?.response?.status === 402 && detail?.code === "purchase_required") {
        setError(detail.message || "Purchase required.");
        return { ok: false, purchaseRequired: true, checkoutUrl: detail.checkout_url || "" };
      }
      setError(formatApiError(e));
      return { ok: false };
    }
  };

  const logout = async () => {
    localStorage.removeItem("btt_token");
    setUser(false);
  };

  const refreshUser = async () => {
    try { const { data } = await api.get("/auth/me"); setUser(data); } catch {}
  };

  return (
    <AuthContext.Provider value={{ user, error, login, adminLogin, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
